import React from 'react';
import { useSelector } from 'react-redux';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import { MainLayout } from '~/src/features/full-buy/containers/MainLayout/MainLayout';
import { HasAgreementPopup } from '~/src/features/full-buy/containers/pages/Address/HasAgreementPopup';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';

import UnifiedAddressForm from './UnifiedAddressForm';

const OneLineAddress = (): JSX.Element => {
    const selectedTariff = useSelector(selectCurrentTariff);
    const { title = '' } = selectedTariff || {};

    return <MainLayout>
        <TextWrapper $lastIndent={false}>
            <H3>{`Проверьте, доступен ли тариф «${title}» по вашему адресу`}</H3>
            <HasAgreementPopup/>
        </TextWrapper>

        <UnifiedAddressForm />
    </MainLayout>;
};

export default OneLineAddress;
